import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AccountLineSubjectService {
  public notifyChangesInSelectedLine: Subject<any>

  constructor() {
     this.notifyChangesInSelectedLine = new Subject();
  }

  public notifyChangesInSelectedLineToOther(data: any) {
    this.notifyChangesInSelectedLine.next(data);
  }



}
